import "../../MainCSS.css";
import { Button, DatePicker, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import React, { useState ,useEffect } from 'react'
import "../../MainCSS.css";
import { toast } from "react-toastify";
import axios from "axios";
import "aos/dist/aos.css";
import { DieCategoryMasterGet, DieSubCategoryMasterByCategoryId } from "../../../AllAPI/MasterAPI/DiesMasterApi";

const DiesMaster = () => {

    const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };



  const [errors, setErrors] = useState({
    dieCategory: "",
    assembly:"",
    dia:"",
    recievedDate:"",
    cavity:"",
    dieName:"",
    remarks:"",
    stat:"",
    hsnCode:"",
    hardness:"",
    dieSubNumber:"",
    supplier:"",
    stdWeight:"",
    finalDieNumber:"",
subDieCategory:"",
job:"",
dieNumber:"",
  });

  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
const[recievedDate, setRecivedDate]=useState("");
  const [diesId, setDiesId] = useState("");
  const [dieCategory, setDieCategory] = useState("");
  const [subDieCategory, setSubDieCategory] = useState("");
    const [assembly, setAssembly] = useState("");
      const [remarks, setRemarks] = useState("");
        const [stat, setStat] = useState("");
          const [hsnCode, setHSNCode] = useState("");
  const [dia, setDia] = useState("");
    const [cavity, setCavity] = useState("");
    const[hardness,setHardness] = useState("");
    const[finalDieNumber , setFinalDieNumber]=useState("");
    const[subDieNumber, setSubDieNumber]=useState("");
    const[dieNumber, setDieNumber]=useState("");
   const[supplier,setSupplier]=useState("");
const[stdWeight,setStdWeight]=useState("");
const[dieName,setDieName]=useState("");
const[job , setJob]=useState("");
const [allSuppliers, setAllSuppliers] = useState([]);

  const [allSubDieCategory, setAllSubDieCategory] = useState([]);
  const [allJobWorker, setAllJobWorker] = useState([]);
  const [allDieNumber, setAllDieNumber] = useState([]);

  const [allDies, setAllDies] = useState([]);
  const [allDieCategory, setAllDieCategory] = useState([]);
  const [submitButton, setSubmitButton] = useState(true);
  const [updateButton, setUpdateButton] = useState(false);

  //======Search data from table===============
  const handleSearch = (value) => {
    const filtered = allDies.filter((item) =>
      Object.values(item).some((val) =>
        (val ?? '').toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length); // Update total entries count after filtering
    setCurrentPage(1);
  };
  //=========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

    // ==============Get table data================
    let isDiesMasterFetched = false;
    useEffect(() => {
      if (isDiesMasterFetched) return;
          fetchDiesMaster();
          fetchDieCategoryMaster();
      isDiesMasterFetched = true;
    }, []);
  
    let isError = false;
  
    const fetchDiesMaster = async () => {
      try {
        // const response = await axios.get(DiesMasterGet,commonHeaders);
        let response
        if (response.data !== null) {
          setAllDies(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Dies Master data:", error);
          toast.error("Failed to fetch Dies Master data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
 const fetchSubDieCategoryMasterByCategory = async (categoryId)  => {
        try {
          const response = await axios.get(`${DieSubCategoryMasterByCategoryId}?dieCategoryId=${categoryId}`,commonHeaders);
          if (response.data !== null) {
            setAllSubDieCategory(response.data);
            
          }
        } catch (error) {
          if (!isError) {
            console.error("Error fetching Sub Die Category Master data:", error);
            toast.error("Failed to fetch Sub Die Category Master data");
            isError = true; // Set the flag to prevent double toast
          }
        }
      };
      const fetchDieCategoryMaster = async () => {
       try {
         const response = await axios.get(DieCategoryMasterGet ,commonHeaders);
         if (response.data !== null) {
           setAllDieCategory(response.data);
          
         }
       } catch (error) {
         if (!isError) {
           console.error("Error fetching DieCategory Master data:", error);
           toast.error("Failed to fetch DieCategory Master data");
           isError = true; // Set the flag to prevent double toast
         }
       }
     };
     const handleDieCategoryChange =async (value) => {
      setDieCategory(value);
      if(value){
     await fetchSubDieCategoryMasterByCategory(value);
    }
      setSubDieCategory(""); 
    };
  const columns = [
    {
      title: "Sr.No.",
      dataIndex: "",
      key: "index",
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: "Category Code",
      dataIndex: "id",
      key: "id",
    },
    {
      title:" Main Category Name",
      dataIndex: "DieCategory",
      key: "DieCategory",
    },
    {
     title:" Sub Category Name",
     dataIndex: "DieCategory",
     key: "DieCategory",
   },
    {
      title: "Description",
      dataIndex: "",
      key: "",
    },
 
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <div>
          <span
            type="submit"
            style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
            onClick={() => handleEditDataButton(record)}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </span>
          <span
            type="submit"
            style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
            onClick={() => handleDeleteData(record)}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        </div>
      ),
    },
  ];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023e7d",
            color: "#fff",
            padding: "10px",
            fontSize: "13px",
            borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
    // ========Submit data to table==============
      const handleSubmit = async () => {
        let isValid = true;
        const errorObj = {};
    
        if (!dieNumber.trim()) {
          isValid = false;
          errorObj.dieNumber = "Die Number is required *";
        }
            
        if (!subDieNumber.trim()) {
          isValid = false;
          errorObj.subDieNumber = " Sub Die Number is required *";
        }
            
        if (!finalDieNumber.trim()) {
          isValid = false;
          errorObj.finalDieNumber = " Final Die Number is required *";
        }
            
        if (!dia.trim()) {
          isValid = false;
          errorObj.dia = "Dia is required *";
        }

        if (!cavity.trim()) {
          isValid = false;
          errorObj.cavity = "Cavity is required *";
        }
        if (!dieCategory || (typeof dieCategory === 'string' && !dieCategory.trim())) {
          isValid = false;
          errorObj.dieCategory = "Die Category Name is required *";
        }
        if(!subDieCategory|| (typeof subDieCategory === 'string' &&!subDieCategory.trim())) {
          isValid = false;
          errorObj.subDieCategory = " Sub Die Category Name is required *";
        }
        if (!hsnCode.trim()) {
          isValid = false;
          errorObj.hsnCode = "HSN Code is required *";
        }
        if (!dieName.trim()) {
          isValid = false;
          errorObj.dieName = "Die Name is required *";
        }
        if (!recievedDate.trim()) {
          isValid = false;
          errorObj.recievedDate = "Date is required *";
        }
        if (!supplier.trim()) {
          isValid = false;
          errorObj.supplier = "Supplier is required *";
        }
        if (!assembly.trim()) {
          isValid = false;
          errorObj.assembly = "Assembly is required *";
        }
        if (!stdWeight.trim()) {
          isValid = false;
          errorObj.stdWeight = "Std. Weight is required *";
        }
        if (!hardness.trim()) {
          isValid = false;
          errorObj.hardness = "Hardness is required *";
        }
        if (!remarks.trim()) {
          isValid = false;
          errorObj.remarks = "Remarks is required *";
        }
        if (!stat.trim()) {
          isValid = false;
          errorObj.stat = "Status is required *";
        }
        if (!job.trim()) {
          isValid = false;
          errorObj.job = "Selection is required *";
        }
        setErrors(errorObj); // Set error messages
    
        if (!isValid) return;
    
        const bodyData = {
          dieNumber: dieNumber,
        
         
        };
    
        try {
          //const response = await axios.post(DiesMasterSave, bodyData ,commonHeaders);
          let response
          if (response.data === "CREATED") {
            toast.success("Dies NUmber added successfully!");
            fetchDiesMaster();
            handleCancel();
          } else if (response.data === "ALREADYEXISTED") {
            toast.warn("Dies Number already exist!");
            //handleCancel();
          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
        }
      };
      //==================== Handle Cancel button =====================
      const handleCancel = () => {
        setUpdateButton(false);
        setSubmitButton(true);
        setAssembly("");
        setCavity("");
        setDia("");
        setDieCategory("");
        setSubDieCategory("");
        setDieName("");
        setHSNCode("");
        setJob("");
        setHardness("");
        setRemarks("");
        setStat("");
        setSupplier("");
        setStdWeight("");
        setDieNumber("");
        setErrors("");
      };
    // ========Update data from table============
    const handleEditDataButton = (item) => {
      setUpdateButton(true);
      setSubmitButton(false);
      window.scrollTo(0, 0);
      setDieNumber(item.dieNumber);
    };
    const handleUpdate = async () => {
      if (!dieNumber) {
      toast.warn("Please enter Number!");
       return
      }
          
      if (!subDieNumber) {
        toast.warn("Please enter  Number!");
        return
      }
          
      if (!finalDieNumber) {
        toast.warn("Please enter  Number!");
return
      }
          
      if (!dia) {
        toast.warn("Please fill all details!");
        return
      }

      if (!cavity) {
        toast.warn("Please fill all details!");
        return
      }
      if (!dieCategory) {
        toast.warn("Please fill all details!");
        return
      }
      
      if (!subDieCategory) {
        toast.warn("Please fill all details!");
        return
      }
      if (!hsnCode) {
        toast.warn("Please fill all details!");
        return
      }
      if (!dieName) {
        toast.warn("Please fill all details!");
        return
      }
      if (!recievedDate) {
        toast.warn("Please fill all details!");
        return
      }
      if (!supplier) {
        toast.warn("Please fill all details!");
        return
      }
      if (!assembly) {
        toast.warn("Please fill all details!");
        return
      }
      if (!stdWeight) {
        toast.warn("Please fill all details!");
        return
      }
      if (!hardness) {
        toast.warn("Please fill all details!");
        return
      }
      if (!remarks) {
        toast.warn("Please fill all details!");
        return
      }
      if (!stat) {
        toast.warn("Please fill all details!");
        return
      }
      if (!job) {
        toast.warn("Please fill all details!");
        return
      }
  
  
     
      const bodyData = {
        id:diesId,
        dieNumber: dieNumber,
  
       
      };
  
      try {
        //const response = await axios.put(DiesMasterUpdate, bodyData ,commonHeaders);
        let response
        if (response.data === "UPDATED") {
          toast.success("Dies Number updated successfully!");
         fetchDiesMaster();
          handleCancel();
        } else if (response.data === "ALREADYEXISTED") {
          toast.warn("Dies Number already exist!");
          //handleCancel();
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while updating data");
      }
    };
   //============================== Delete data from table ======================================
   const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Dies "${item.dieNumber}"?`
    );
    if (!confirmDelete) return;
  
    try {
  // const response = await axios.delete(
  // `${DiesMasterDelete}?id=${item.id}`,commonHeaders
  //    );
  let response
      if (response.data === "DELETED") {
        toast.success("Dies deleted successfully!");
        fetchDiesMaster();
        handleCancel();
      }
    } catch (error) {
      console.error("Error during delete operation:", error);
      toast.error("Error occurred while deleting ");
    }
  };
  
return (
  <div className="px-5 py-3">
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">


  <div className="p-0 m-0">
  
  <div className="row px-md-5 mt-3 p-2 justify-content-center">
  <div className="col-11">
    <div className="p-0 m-0">
      
      {/* First Row */}
      <div className="row">
        {/* Date Received */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Date Received</label>
          <DatePicker
            value={recievedDate}
            onChange={(date) => setRecivedDate(date)}
            placeholder="Enter Date Received"
            style={{ width: '100%' }}
          />
          {errors.recievedDate && <div className="errorField">{errors.recievedDate}</div>}
        </div>
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Supplier/Job Worker</label>
          <Select
            value={job}
            onChange={(value) => setJob(value)}
            placeholder="Select Supplier/Job Worker"
            style={{ width: '100%' }}
            showSearch
            optionFilterProp="label"
          >
            <Option value="1">Supplier</Option>
            <Option value="2">Job Worker</Option>
          </Select>
          {errors.job && <div className="errorField">{errors.job}</div>}
        </div>

        {/* Supplier/Job Worker */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Supplier Name</label>
          <Select
            value={supplier}
            onChange={(value) => setSupplier(value)}
            placeholder="Select Supplier/ Job Worker"
            style={{ width: '100%' }}
            showSearch
            optionFilterProp="label"
          >
            {allSuppliers.map((supplier) => (
              <Option key={supplier.id} value={supplier.id}>
                {supplier.name}
              </Option>
            ))}
          </Select>
          {errors.supplier && <div className="errorField">{errors.supplier}</div>}
        </div>

      </div>

      {/* Second Row */}
      <div className="row">
      
        {/* Die Number */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Die Number</label>
          <Input
            value={dieNumber}
            onChange={(e) => setDieNumber(e.target.value)}
            placeholder="Enter Die Number"
            style={{ width: '100%' }}
          />
          {errors.dieNumber && <div className="errorField">{errors.dieNumber}</div>}
        </div>
        {/* Die Name */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Die Name</label>
          <Input
            value={dieName}
            onChange={(e) => setDieName(e.target.value)}
            placeholder="Enter Die Name"
            style={{ width: '100%' }}
          />
          {errors.dieName && <div className="errorField">{errors.dieName}</div>}
        </div>

        {/* Die Sub-Number */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Die Sub-No.</label>
          <Input
            value={subDieNumber}
            onChange={(e) => setSubDieNumber(e.target.value)}
            placeholder="Enter Die Sub-No."
            style={{ width: '100%' }}
          />
          {errors.dieSubNumber && <div className="errorField">{errors.dieSubNumber}</div>}
        </div>

       
      </div>

      {/* Third Row */}
      <div className="row">
       {/* Final Die Number */}
       <div className="col-10 col-md-4 mb-3">
          <label className="labels">Final Die Number</label>
          <Input
            value={finalDieNumber}
            onChange={(e) => setFinalDieNumber(e.target.value)}
            placeholder="Enter Final Die Number"
            style={{ width: '100%' }}
          />
          {errors.finalDieNumber && <div className="errorField">{errors.finalDieNumber}</div>}
        </div>
        {/* Die Category */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Die Category</label>
          <Select
            value={dieCategory}
            onChange={handleDieCategoryChange}
            placeholder="Select Die Category"
            style={{ width: '100%' }}
            showSearch
            optionFilterProp="label"
          >
            {allDieCategory.map((category) => (
              <Option key={category.id} value={category.id}>
                {category.dieCategoryName}
              </Option>
            ))}
          </Select>
          {errors.dieCategory && <div className="errorField">{errors.dieCategory}</div>}
        </div>

        {/* Die Sub-Category */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Die Sub-Category</label>
          <Select
            value={subDieCategory}
            onChange={(value) => setSubDieCategory(value)}
            placeholder="Select Die Sub-Category"
            style={{ width: '100%' }}
            showSearch
            optionFilterProp="label"
          >
            {allSubDieCategory.map((category) => (
              <Option key={category.id} value={category.id}>
                {category.subDieCategoryName}
              </Option>
            ))}
          </Select>
          {errors.subDieCategory && <div className="errorField">{errors.subDieCategory}</div>}
        </div>

      
      </div>

      {/* Fourth Row */}
      <div className="row">
        {/* HSN Code */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">HSN CODE</label>
          <Input
            value={hsnCode}
            onChange={(e) => setHSNCode(e.target.value)}
            placeholder="Enter HSN CODE"
            style={{ width: '100%' }}
          />
          {errors.hsnCode && <div className="errorField">{errors.hsnCode}</div>}
        </div>
        {/* Assembly */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Assembly</label>
          <Input
            value={assembly}
            onChange={(e) => setAssembly(e.target.value)}
            placeholder="Enter Assembly"
            style={{ width: '100%' }}
          />
          {errors.assembly && <div className="errorField">{errors.assembly}</div>}
        </div>

        {/* Cavity */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Cavity</label>
          <Input
            value={cavity}
            onChange={(e) => setCavity(e.target.value)}
            placeholder="Enter Cavity"
            style={{ width: '100%' }}
          />
          {errors.cavity && <div className="errorField">{errors.cavity}</div>}
        </div>

      </div>

      {/* Fifth Row */}
      <div className="row">
      
        {/* Std. Weight Range */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Std. Weight Range</label>
          <Input
            value={stdWeight}
            onChange={(e) => setStdWeight(e.target.value)}
            placeholder="Enter Std. Weight Range"
            style={{ width: '100%' }}
          />
          {errors.stdWeight && <div className="errorField">{errors.stdWeight}</div>}
        </div>
        {/* Dia */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Dia</label>
          <Input
            value={dia}
            onChange={(e) => setDia(e.target.value)}
            placeholder="Enter Dia"
            style={{ width: '100%' }}
          />
          {errors.dia && <div className="errorField">{errors.dia}</div>}
        </div>

        {/* Hardness */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Hardness</label>
          <Input
            value={hardness}
            onChange={(e) => setHardness(e.target.value)}
            placeholder="Enter Hardness"
            style={{ width: '100%' }}
          />
          {errors.hardness && <div className="errorField">{errors.hardness}</div>}
        </div>

      </div>

      {/* Sixth Row */}
      <div className="row">
      
        {/* Remarks */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Remarks</label>
          <Input.TextArea
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Enter Remarks"
            style={{ width: '100%' }}
          />
          {errors.remarks && <div className="errorField">{errors.remarks}</div>}
        </div>
        {/* Status */}
        <div className="col-10 col-md-4 mb-3">
          <label className="labels">Status</label>
          <Select
            value={stat}
            onChange={(value) => setStat(value)}
            placeholder="Select Status"
            style={{ width: '100%' }}
             showSearch
            optionFilterProp="label"
          >
            <Option value="Active">Active</Option>
            <Option value="Inactive">Inactive</Option>
            <Option value="Scrap">Scrap</Option>
          </Select>
          {errors.stat && <div className="errorField">{errors.stat}</div>}
        </div>
      </div>
    
        
            <div className="col-12 text-center">
              <Button
                type="submit"
                className="CancelBtn mx-1"
                 onClick={handleCancel}
              >
                Cancel
              </Button>
              {submitButton && (
                <Button
                  type="submit"
                  className="SubmitBtn mx-1"
                   onClick={handleSubmit}
                >
                  Submit
                </Button>
              )}
              {updateButton && (
                <Button
                  type="submit"
                  className="UpdateBtn mx-1"
                   onClick={handleUpdate}
                >
                  Update
                </Button>
              )}
            </div>
    
          </div>
        </div>
      </div>
    
      <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>
    
      {/*================ Table =========================*/}
      <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
        <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
          <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
              <Select
                defaultValue={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: 120, textAlign: "center" }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
              </Select>
            </div>
    
            <div className="pt-4 pt-md-0">
              <Input.Search
                placeholder="Search"
                onSearch={handleSearch}
                style={{ width: 200, marginBottom: 16 }}
              />
            </div>
          </div>
    
          <div style={{ backgroundColor: "white" }}>
            <Table
              bordered
              style={{ padding: "0px 20px", overflowX: "auto" }}
              columns={columns}
              dataSource={filteredData}
              pagination={{
                pageSize: pageSize,
                total: totalEntries,
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
              }}
              showSorterTooltip={false}
              rowKey={(record) => record.id}
              components={components}
            />
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>)
}

export default DiesMaster